var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 5C16.2 5 5 16.2 5 30C5 43.8 16.2 55 30 55C43.8 55 55 43.8 55 30C55 16.2 43.8 5 30 5ZM30 15C34.825 15 38.75 18.925 38.75 23.75C38.75 28.575 34.825 32.5 30 32.5C25.175 32.5 21.25 28.575 21.25 23.75C21.25 18.925 25.175 15 30 15ZM30 50C24.925 50 18.925 47.95 14.65 42.8C18.875 39.5 24.2 37.5 30 37.5C35.8 37.5 41.125 39.5 45.35 42.8C41.075 47.95 35.075 50 30 50Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/Account_circle.32314d5d22cfc18e7b1697dd93f9fc20.svg";
export { ForwardRef as ReactComponent };